import React from 'react'
import classnames from 'classnames'

const PlanRadioButton = props => (
  <label className={classnames('plan-radio-button', {
    selected: props.selected,
    disabled: props.disabled,
  })}>
    <div className="primary-text">
      <div>{props.primaryLeft}</div>
      <div>{props.primaryRight}</div>
    </div>
    <div className="secondary-text">
      <div>{props.secondaryLeft}</div>
      <div>{props.secondaryRight}</div>
    </div>
    <input
      onChange={props.onChange}
      checked={props.checked}
      type="radio"
      name={props.name}
      value={props.value}
      disabled={props.disabled} />
  </label>
)

export default PlanRadioButton


// WEBPACK FOOTER //
// client/components/sections/Billing/PlanRadioButton.js